<template>
  <vs-popup fullscreen :active.sync="isSidebarActiveLocal"
    :title=" Object.entries(this.data).length === 0 ? 'Yeni Ürün' : 'Ürün Düzenle'" v-esc="escape">
    <vs-popup class="holamundo" title="Varyant Sil" :active.sync="deletePopupActive" v-esc="escapeDelete">
      <vs-row vs-type="flex" vs-w="12">
        <p>Bu Varyantı Silmek İstediğinize Eminmisiniz ? </p>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-3" vs-justify="space-between">
        <vs-button type="gradient" color="primary" @click="deletePopupActive = false;deletedId = null">Vazgeç</vs-button>
        <vs-button type="gradient" color="danger" icon-pack="feather" icon="icon-trash"
          @click="deleteVariant(deletedId)">
          Sil
        </vs-button>
      </vs-row>
    </vs-popup>
    <new-variant-add ref="newVariantAdd" @reloadTree="doReloadTree" />
    <branch-product-price ref="newBranchProductPrice"/>
    <vs-row vs-type="flex" vs-w="12">
      <vs-col vs-w="3" class="px-2">
        <div @keyup.enter="submitData">
          <template v-if="newProduct.imageUrl">

            <!-- Image Container -->
            <div class="img-container w-64 mx-auto flex items-center justify-center">
              <img v-if="!needUpload" :src="$baseUrl + '/' + newProduct.imageUrl" alt="img" class="responsive">
              <img v-else :src="newProduct.imageUrl" alt="img" class="responsive">
            </div>

            <!-- Image upload Buttons -->
            <div class="modify-img flex justify-between mt-5">
              <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
              <vs-button class="mr-4" type="gradient" @click="$refs.updateImgInput.click()">Fotoğrafı Güncelle
              </vs-button>
              <vs-button type="gradient" color="danger"
                @click="newProduct.imageUrl = null;needUpload=false;productPhotoBinary=null;">
                Fotoğrafı Sil

              </vs-button>
            </div>
          </template>

          <div class="upload-img" v-if="!newProduct.imageUrl">
            <input type="file" class="hidden" ref="uploadImgInput" @change="updateCurrImg" accept="image/*">
            <vs-button class="w-full" icon-pack="feather" icon="icon-arrow-up" @click="$refs.uploadImgInput.click()">
              Fotoğraf Yükle
            </vs-button>

          </div>
          <vs-row class="mb-6">
            <vs-col class="w-full">
              <vs-input id="name" name="İsim" v-validate="'required|min:2|max:60'" v-model="newProduct.name"
                class="w-full" icon-pack="feather" icon="icon-user" label-placeholder="İsim" />
              <span class="text-danger text-sm"
                v-show="errors.has('form-1.İsim')">{{ errors.first("form-1.İsim")}}</span>
            </vs-col>
          </vs-row>

          <vs-row class="mb-6">
            <vs-col class="w-full">
              <vs-textarea id="description" name="Açıklama" v-model="newProduct.description" class="w-full mt-1"
                label="Açıklama" />
            </vs-col>
          </vs-row>
          <vs-row class="mb-6">
            <vs-col class="w-full">
              <label>Mutfak Seçimi (Birden Fazla Seçilebilir)</label>
              <v-select class="w-full"
                  v-model="selectedKitchens" :multiple="true" itemid="id" label="name" placeholder="Mutfak(lar) Seçiniz.." :options="kitchens"
                 ></v-select>
            </vs-col>
          </vs-row>
          <vs-row class="mb-6">
            <vs-col class="w-full">
              <vs-input id="priority" name="Öncelik" type="number" v-model="newProduct.priority"
                class="w-full" icon-pack="feather" icon="icon-star" label-placeholder="Öncelik puanı" />
            </vs-col>
          </vs-row>
          <vs-row class="mb-6">
            <vs-col class="w-full">
              <label>Menüde Göster:</label>
              <vs-switch v-model="newProduct.isShowMenu" style="width: 75px !important;" color="success">
                <span slot="on">Göster</span>
                <span slot="off">Gizle</span>
              </vs-switch>
            </vs-col>
          </vs-row>
          <vs-row class="mb-6 " vs-type="flex" vs-w="12">
            <vs-col class="w-full" vs-justify="space-between" vs-type="flex">
              <vs-button size="large" class="mr-3 mb-2 " type="gradient" color="danger"
                @click="isSidebarActiveLocal = false">
                Vazgeç
              </vs-button>
              <vs-button size="large" class="mb-2 " type="gradient" color="success" @click="submitData">Kaydet

              </vs-button>

            </vs-col>
          </vs-row>
        </div>
      </vs-col>
      <vs-col v-if="newProduct.id > 0" vs-w="9">
        <vs-row vs-w="3">
          <vs-button @click="addNewVariant">Varyant Ekle</vs-button>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12">
          <parent-variant v-if="variantTree.length > 0" :parent="variantTree" :parentRefs="$refs"
            style="margin-left:-1rem;" />
        </vs-row>
      </vs-col>
      <vs-row>
      </vs-row>
    </vs-row>
  </vs-popup>
</template>

<script>
  import NewVariantAdd from "./NewVariantAdd.vue";
  import BranchProductPrice from "./branchProductPrice.vue";
  import VuePerfectScrollbar from "vue-perfect-scrollbar";
  import ParentVariant from "./parentVariant.vue"
  import { getAllKitchen } from "@/api/Kitchen";
  import {
    createNewProduct,
    updateProduct,
    uploadImage,
    getRecipeList,
    getProductById,
    deleteProduct
  } from "@/api/Product";
  import {
    getProductableCategoryNameList
  } from "@/api/ProductCategory";

  export default {

    components: {
      VuePerfectScrollbar,
      NewVariantAdd,
      ParentVariant,
      BranchProductPrice
    },

    props: {
      isSidebarActive: {
        type: Boolean,
        required: true
      },
      data: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        treeData: [],
        treeOptions: {
          propertyNames: {
            text: "name",
            children: "children"
          }
        },
        deletePopupActive: false,
        deletedId: null,
        newVariant: null,
        recipes: [],
        categories: [],
        needUpload: false,
        newProduct: {
          imageUrl: "",
          kitchen: null,
          isShowMenu: false,
          priority: 0
        },
        selected: null,
        sidebarData: {},
        productPhotoBinary: "",
        settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60
        },
        addNewDataSidebar: false,
        variantTree: [],
        kitchens: [],
        selectedKitchens: []
      };
    },
    computed: {
      isSidebarActiveLocal: {
        get() {
          return this.isSidebarActive;
        },
        set(val) {
          if (!val) {
            this.$emit("closeSidebar", false);
            this.$validator.reset();
            this.initValues();
          }
        }
      }
    },
    async created(){
      this.kitchens = (await getAllKitchen()).data;

      console.log(this.newProduct);
    },
    methods: {
      escapeDelete() {
        this.deletePopupActive = false;
        this.deletedId = null;
      },
      escape() {
        if (this.isSidebarActiveLocal == true && this.$refs.newVariantAdd.isActive == false) this.isSidebarActiveLocal =
          false;
      },
      deleteVariant(id) {
        deleteProduct(id).then(res => {
          if (res && res.status == 200) {
            this.$vs.notify({
              color: "success",
              title: "Başarılı !",
              text: "Varyant Silme Başarılı !"
            });
            this.getProductById(this.newProduct.id);
            this.deletePopupActive = false;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status || "",
              text: "Varyant Silme Başarısız !"
            });
          }
        }).catch(x => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Varyant Silinemedi !"
          });
        });
      },
      getProductById: function (id) {
        getProductById(id).then(res => {
          if (res && res.status == 200) {
            this.variantTree = [];
            this.newProduct = _.cloneDeep(res.data);

            this.$nextTick(() => {
              if (this.newProduct.kitchenIds && this.newProduct.kitchenIds.length > 0) {
                this.selectedKitchens = this.kitchens.filter(x => this.newProduct.kitchenIds.includes(x.id));
              } else if (this.newProduct.kitchenId) {
                const k = this.kitchens.find(x => x.id == this.newProduct.kitchenId);
                this.selectedKitchens = k ? [k] : [];
              } else {
                this.selectedKitchens = [];
              }
              console.log(this.newProduct);
              res.data.children.forEach(variant => {
                this.variantTree.push(variant);
              });
              if (this.variantTree.children == null) this.variantTree.children = [];
            });

            this.needUpload = false;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status || "",
              text: "Ürün Varyasyonları Yüklenemedi !"
            });
          }
        }).catch((e) => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: e.message
          });
        });

      },
      addNewVariant() {
        this.$refs.newVariantAdd.isActive = true;
        this.$refs.newVariantAdd.newVariant = {
          rootId: this.newProduct.id
        };
        this.$refs.newVariantAdd.rootName = this.newProduct.name;
      },
      doReloadTree() {
        this.getProductById(this.newProduct.id);
      },
      loadKitchenList: function () {
        getAllKitchen().then(res => {
          if (res && res.status == 200) {
            this.kitchens = res.data;
            if (this.newProduct.kitchenIds && this.newProduct.kitchenIds.length > 0) {
              this.selectedKitchens = this.kitchens.filter(x => this.newProduct.kitchenIds.includes(x.id));
            } else if (this.newProduct.kitchenId) {
              const k = this.kitchens.find(x => x.id == this.newProduct.kitchenId);
              this.selectedKitchens = k ? [k] : [];
            } else {
              this.selectedKitchens = [];
            }
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status || "",
              text: "Mutfaklar Yüklenemedi !"
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !"
          });
        });
      },
      getProductableCategoryNameList: function () {
        getProductableCategoryNameList().then(res => {
          if (res && res.status == 200) {
            this.categories = res.data;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status || "",
              text: "Kategoriler Yüklenemedi !"
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Kategoriler Yüklenemedi !"
          });
        });
      },
      getRecipeList: function () {
        getRecipeList().then(res => {
          if (res && res.status == 200) {
            this.recipes = res.data.items;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status || "",
              text: "Tarifler Yüklenemedi !"
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Tarifler Yüklenemedi !"
          });
        });
      },
      uploadImage: async function () {
        let image = this.productPhotoBinary;
        let formData = new FormData();
        formData.append("image", image);
        await uploadImage(formData).then(res => {
          if (res && res.status == 200) {
            this.newProduct.imageUrl = "StaticFiles/images/" + res.data;
            this.needUpload = false;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Seçilen Fotoğraf Yüklenemedi !"
            });
          }
        });
      },
      initValues: function () {
        this.needUpload = false;
        this.newProduct = {
          imageUrl: "",
          isShowMenu: false,
          priority: 0,
          kitchenIds: []
        };
        this.selectedKitchens = [];
        this.variantTree = [];
        this.productPhotoBinary = "";
      },
      submitData: async function () {
        let checker;
        checker = await this.$validator.validateAll("form-1");
        if (checker) {
          console.log(this.newProduct);
          if (Array.isArray(this.selectedKitchens) && this.selectedKitchens.length > 0) {
            this.newProduct.kitchenIds = this.selectedKitchens.map(x => x.id);
            this.newProduct.kitchenId = this.selectedKitchens[0].id;
          } else {
            this.newProduct.kitchenIds = [];
            this.newProduct.kitchenId = null;
          }
          this.newProduct.price = this.newProduct.price ? parseFloat(this.newProduct.price) : 0;
          if ((this.newProduct.imageUrl !== null || this.newProduct.imageUrl != "") && this.needUpload === true) {
            await this.uploadImage();
          } else if (this.newProduct.imageUrl == null || this.newProduct.imageUrl == "") {
            this.$vs.notify({
              color: "danger",
              title: "Hata : ",
              text: "Fotoğraf Seçmeniz Gerekiyor !"
            });
            return;
          }
          //await this.mapNewBranch();
          if (this.newProduct.id) {

            updateProduct(this.newProduct).then(res => {
              if (res && res.status === 200) {
                this.$store.dispatch("product/updateProduct", res.data).then(() => {
                  this.$vs.notify({
                    color: "success",
                    title: "Başarılı !",
                    text: "Ürün Güncelleme Başarılı !"
                  });
                });
              } else {
                this.$vs.notify({
                  color: "danger",
                  title: "Hata : " + res.status,
                  text: "Ürün Güncelleme Başarısız !"
                });
              }
            }).catch(err => {
              this.$vs.notify({
                color: "danger",
                title: "Hata !",
                text: "Ürün Güncelleme Başarısız ! "
              });
            });
          } else {

            this.newProduct.id = 0;
            createNewProduct(this.newProduct).then(res => {
              if (res && res.status === 200) {

                this.$store.dispatch("product/addProduct", res.data).then(() => {
                  this.$vs.notify({
                    color: "success",
                    title: "Başarılı",
                    text: "Ürün Ekleme Başarılı !"
                  });
                  this.newProduct = res.data;

                });
              } else {
                this.$vs.notify({
                  color: "danger",
                  title: "Hata : " + res.status,
                  text: "Ürün Ekleme Başarısız !"
                });
              }
            }).catch(() => {
              this.$vs.notify({
                color: "danger",
                title: "Hata !",
                text: "Sunucu Bağlantı Hatası !"
              });
            });
          }
        }
      },
      mapNewProduct: async function () {
        //map
      },
      updateCurrImg(input) {
        this.needUpload = true;
        if (input.target.files && input.target.files[0]) {
          var reader = new FileReader();
          reader.onload = e => {
            this.newProduct.imageUrl = e.target.result;
          };
          reader.readAsDataURL(input.target.files[0]);
          this.productPhotoBinary = input.target.files[0];
        }
      },

      setKitchhenSelect: function () {
        if (this.newProduct.kitchenIds && this.newProduct.kitchenIds.length > 0) {
          this.selectedKitchens = this.kitchens.filter(x => this.newProduct.kitchenIds.includes(x.id));
        } else if (this.newProduct.kitchenId) {
          const k = this.kitchens.find(x => x.id == this.newProduct.kitchenId);
          this.selectedKitchens = k ? [k] : [];
        } else {
          this.selectedKitchens = [];
        }
        console.log(this.newProduct);
      }
    },

    watch: {
      isSidebarActive: function (val) {
        if (!val) return;
        if (this.data.id == null) {
          this.initValues();
          this.$validator.reset();
        } else {
          this.needUpload = false;
          this.getProductById(this.data.id);
        }
      },
      data: {
    immediate: true,
    handler(newVal) {
      if (newVal && newVal.kitchenId) {
        console.log(newVal);
        this.$nextTick(() => {
          //this.newProduct.kitchen = this.kitchens.find(x => x.id === newVal.kitchenId);
        });
      }
    }
  }
    },
     mounted: function () {
      this.getRecipeList();
      this.getProductableCategoryNameList();
      this.loadKitchenList();
     // this.setKitchhenSelect();
    },
  };

</script>

<style lang="scss" scoped>
  .vs-con-textarea {
    margin-bottom: 0px;
  }

  .vs__dropdown-menu {
    max-height: 25vh !important;
    overflow-x: hidden !important;
    overflow-y: scroll !important;
    position: absolute !important;
  }

  .tree-col {
    border: .1rem solid #000000 !important;
    padding: 1rem !important;
    flex-direction: column !important;
  }

</style>
